import styled from "styled-components";

import Button from "components/buttons/Button";

const AddRowButton = styled(Button)`
  height: 2.5em;
  width: 100%;
  border-radius: 0;
`;

export default AddRowButton;
